import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_pos-logged_out_footer_banner-click';
/**
 * Logged out user clicked the POS banner on page footer
 */
export function trackRetailerPosLoggedOutFooterBannerClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
